module.exports = __webpack_public_path__ + "images/ios.639bbeb3.svg";